import React from 'react';
import { motion } from 'framer-motion';
import { scrollToComprar } from '../utils';
import { ShieldCheck, Star } from 'lucide-react';
export function Hero() {
  return <section className="bg-primary text-cream pt-10 pb-12 px-4 md:pt-14 md:pb-16 overflow-hidden" data-id="element-96">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center space-y-6" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-5 max-w-3xl" data-id="element-98">
          <div className="inline-flex items-center gap-2 bg-primary-light/50 px-4 py-2 rounded-full border border-primary-light" data-id="element-99">
            <div className="flex gap-1 text-accent" data-id="element-100">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" data-id="element-101" />)}
            </div>
            <span className="text-sm font-medium text-cream-dark" data-id="element-102">
              Más de 5.000 perros más sanos
            </span>
          </div>

          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-tight" data-id="element-103">
            La guía simple para mejorar la salud de tu perro con{' '}
            <span className="text-accent" data-id="element-104">comida natural</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative w-[96%]" data-id="element-105">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] bg-primary-light/20 rounded-full blur-3xl -z-10" data-id="element-106"></div>
          <button onClick={scrollToComprar} className="block w-full focus:outline-none focus:ring-4 focus:ring-accent/50 rounded-2xl" aria-label="Ir a la sección de compra" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/hSsoQJf5zRtD7qPwsyjzjt/IMG_0533_(2).png" alt="Ebook Comida Natural para Perros con sus bonos complementarios" className="w-full h-auto mx-auto transition-transform duration-500 hover:scale-105 cursor-pointer" data-id="element-108" />
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="space-y-5 max-w-3xl" data-id="element-109">
          <p className="text-lg md:text-xl text-cream-dark/90 max-w-2xl mx-auto" data-id="element-110">
            Dejá atrás el alimento balanceado lleno de químicos. Eliminá
            alergias, picazón y enfermedades con recetas caseras fáciles,
            económicas y 100% naturales.
          </p>

          <div className="pt-2 flex flex-col sm:flex-row gap-4 justify-center" data-id="element-111">
            <button onClick={scrollToComprar} className="bg-accent hover:bg-accent-hover text-white font-bold text-lg py-4 px-8 rounded-xl shadow-lg transform transition hover:-translate-y-1 w-full sm:w-auto" data-id="element-112">
              QUIERO ALIMENTAR MEJOR A MI PERRO
            </button>
          </div>

          <div className="flex items-center justify-center gap-2 text-sm text-cream-dark/80" data-id="element-113">
            <ShieldCheck size={16} className="text-accent" data-id="element-114" />
            <span data-id="element-115">Garantía de satisfacción de 7 días</span>
          </div>
        </motion.div>
      </div>
    </section>;
}